import telegram from './telegram.svg';
import viber from './viber.svg';
import whatsapp from './whatsapp.svg';
import vk from './vk.svg';

export const socials = { telegram, viber, whatsapp, vk };
